import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import GrnPOModal from "../components/grnPoModal";
import Time from "../components/time";
import { useParams, useNavigate, Link } from "react-router-dom";
import Swal from "sweetalert2";

const GrnInspection = () => {
  useAuthRedirect();
  const { grnNo, poNo } = useParams();
  const [showModal, setShowModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]); 
  const branch = localStorage.getItem("branch");
  const user = localStorage.getItem("username");
  const [detail, setGrnDetail] = useState({});  
  const [supplierNo, setSupplierNo] = useState(null);  
  const [poDate, setPoDate] = useState(null);  
const [freight, setFreight] = useState(""); 
const [subDetails, setSubDetails] = useState({})
const [formData, setFormData] = useState({
  // rejectReason : "",
})
const [rejectReasons, setRejectReasons] = useState({});
const navigate = useNavigate();
const [quantities, setQuantities] = useState({}); 


useEffect(() => {
    const fetchGrnDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/grnInspection_detailsHeader?branch=${branch}&grnNo=${grnNo}`);
        if (response.data && response.data.headerDetails?.length > 0) {
            const items = response.data.headerDetails;

            const storeReqHeader = {
                grnheader_date: items[0].grnheader_date || "N/A",
                purchaseOrderHeader_podate: items[0].purchaseOrderHeader_podate || "N/A",
                grnheader_DcNumber: items[0].grnheader_DcNumber || "N/A",
                grnheader_DcDate: items[0].grnheader_DcDate || "N/A",
                grnheader_invoiceDate: items[0].grnheader_invoiceDate || "N/A",
                grnheader_invoiceNumber: items[0].grnheader_invoiceNumber || "N/A",
                grnheader_suppliercode: items[0].grnheader_suppliercode || "N/A",
                GrnHeader_poDate: items[0].GrnHeader_poDate || "N/A",
            };

            setGrnDetail(storeReqHeader);
        }
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchGrnDetails();
  }, [branch, grnNo]); 


  const [loading, setLoading] = useState(true); // state for loading

useEffect(() => {
  const fetchData = async () => {
    try {
      setLoading(true); // start loading
      const response = await axios.get(
        `https://rfs2.infraconsoft.net.in/api/grnInspection_data?branch=${branch}&grnNo=${grnNo}&poNo=${poNo}`
      );
      setSelectedItems(response.data.grnInspectionData);
    } catch (error) {
      console.error("Error fetching grnInspectionData:", error);
    } finally {
      setLoading(false); // stop loading
    }
  };
  fetchData();
}, [branch, grnNo, poNo]);


useEffect(() => {
    const fetchSupplierDetails = async () => {
      try {
        const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/purchaseOrder_supDetails?supplierCode=${detail.grnheader_suppliercode}`);
            const items = response.data.supDetails;
            const storeReqHeader1 = {
                supplierMaster_code: items[0].supplierMaster_code || "N/A",
                supplierMaster_name: items[0].supplierMaster_name || "N/A",
                address1: items[0].supplierMaster_addressline1 || "N/A",
                address2: items[0].supplierMaster_addressline2 || "N/A",
                city: items[0].supplierMaster_city || "N/A",
                pincode: items[0].supplierMaster_pincode || "N/A",
            };
            setSubDetails(storeReqHeader1);
      } catch (error) {
        console.error("Error fetching locations:", error);
      }
    };

    fetchSupplierDetails();
  }, [detail.grnheader_suppliercode]); 

  const handleQuantityChange = (index, value) => {
    if (value === "") {
      setQuantities({ ...quantities, [index]: "" }); 
      return;
    }
  
    const newValue = Number(value);
    const totalQuantity = selectedItems[index].grnDetail_poPendingQuantity;
  
    if (newValue > totalQuantity) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Quantity!",
        text: `Accepted quantity cannot be more than ${totalQuantity}.`,
        confirmButtonText: "OK",
      });
  
      return; // Stop further execution
    }
  
    
    setQuantities({ ...quantities, [index]: newValue });
  };
  
  

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleRejectReasonChange = (index, value) => {
    setRejectReasons((prev) => ({
        ...prev,
        [index]: value, 
    }));
};


 const handleSubmit = async (e) => {
  e.preventDefault();

  if (selectedItems.length === 0) {
    Swal.fire("Error", "Please add at least one item", "error");
    return;
  }

  // ✅ Validate accepted quantity & reject reason
  for (let i = 0; i < selectedItems.length; i++) {
    const item = selectedItems[i];
    const acceptedQuantity = quantities[i];

    // Check if number
    if (
      acceptedQuantity === undefined ||
      acceptedQuantity === null ||
      acceptedQuantity.toString().trim() === "" ||
      isNaN(acceptedQuantity)
    ) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Quantity",
        text: `Please enter a valid accepted quantity for item "${item.itemmaster_name}".`,
      });
      return;
    }

    // Check positive & not zero
    if (Number(acceptedQuantity) <= 0) {
      Swal.fire({
        icon: "warning",
        title: "Invalid Quantity",
        text: `Accepted quantity for item "${item.itemmaster_name}" must be greater than 0.`,
      });
      return;
    }

    // Calculate rejected qty
    const totalQuantity = item.grnDetail_poPendingQuantity;
    const rejectedQuantity = totalQuantity - Number(acceptedQuantity);

    // If rejected qty > 0 → reason required
    if (rejectedQuantity > 0) {
      const reason = rejectReasons[i] || "";
      if (reason.trim() === "") {
        Swal.fire({
          icon: "warning",
          title: "Missing Reject Reason",
          text: `Please provide a reject reason for item "${item.itemmaster_name}" (Rejected Qty: ${rejectedQuantity}).`,
        });
        return;
      }
    }
  }

  const payload = {
    branch: branch,
    user: user,
    grnNo: grnNo,
    grnDate: detail.grnheader_date,
    scode: subDetails.supplierMaster_code,
    dcNo: detail.grnheader_DcNumber,
    dcDate: detail.grnheader_DcDate,
    invoiceNo: detail.grnheader_invoiceNumber,
    invoiceDate: detail.grnheader_invoiceDate,
    poNo: poNo,
    items: selectedItems.map((item, index) => {
      const acceptedQuantity = Number(quantities[index]) || 0;
      const totalQuantity = item.grnDetail_poPendingQuantity;
      const rejectedQuantity =
        acceptedQuantity === 0 ? 0 : totalQuantity - acceptedQuantity;
      const acceptValue = acceptedQuantity * item.grnDetail_price;

      const discountValue =
        acceptValue * (item.grnDetail_discountPercentage / 100);
      const pfValue = acceptValue * (item.grnDetail_pfPercentage / 100);
      const taxValue = acceptValue * (item.grnDetail_taxPercentage / 100);
      const totalValue =
        item.grnHeader_freightCharges +
        acceptValue +
        taxValue +
        pfValue -
        discountValue;

      return {
        itemCode: item.grnDetail_itemcode,
        itemName: item.itemmaster_name,
        itemUom: item.itemMaster_purchaseUom,
        poDate: item.grnDetail_poDate,
        price: item.grnDetail_price,
        poPendingQty: item.grnDetail_poPendingQuantity,
        accQty: acceptedQuantity,
        rejectedQty: rejectedQuantity,
        acceptValue: acceptValue,
        rejectReason: rejectReasons[index] || "",
        tax: item.grnDetail_taxPercentage,
        pf: item.grnDetail_pfPercentage,
        disc: item.grnDetail_discountPercentage,
        totalValue: totalValue,
      };
    }),
  };

  try {
    Swal.fire({
      title: "Submitting...",
      text: "Please wait while we process your request.",
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    const response = await axios.post(
      "https://rfs2.infraconsoft.net.in/api/grnInspection_insert",
      payload
    );

    Swal.fire("Success", "GRN added successfully", "success");
    setSelectedItems([]);
    navigate("/inventory/grnInspection");
  } catch (error) {
    console.error("Error submitting form:", error);
    Swal.fire("Error", "Submission failed. Please try again.", "error");
  }
};


  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
              <h2 className="add-txt">GRN Inspection - Add</h2>
              <Link to='/inventory/grnInspection'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
            </div>
          <Time />
        </section>

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>
          <div className="form-row">
              <div className="form-group">
                <label>GRN Number :</label>
                <input type="text" name="PoNumber" value={grnNo} readOnly />
              </div>
              <div className="form-group">
                <label>GRN Date :</label>
                <input type="text" name="invoiceDate" value={detail.grnheader_date ? new Date(detail.grnheader_date).toLocaleDateString("en-GB") : ""}  onChange={handleChange} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>PO No :</label>
                <input type="text" name="PoNumber" value={poNo} readOnly />
              </div>
              <div className="form-group">
                <label>PO Date :</label>
                <input type="text" name="invoiceDate" value={detail.GrnHeader_poDate ? new Date(detail.GrnHeader_poDate).toLocaleDateString("en-GB") : ""}  onChange={handleChange} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Supplier Code :</label>
                <input type="text" name="scode" value={subDetails.supplierMaster_code} readOnly/>
              </div>
              <div className="form-group">
                <label>Supplier Name :</label>
                <input type="text" name="sname" value={subDetails.supplierMaster_name} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>DC No :</label>
                <input type="text" name="dcNo" value={detail.grnheader_DcNumber}  onChange={handleChange} readOnly/>
              </div>
              <div className="form-group">
                <label>DC Date :</label>
                <input type="text" name="invoiceDate" value={detail.grnheader_DcDate ? new Date(detail.grnheader_DcDate).toLocaleDateString("en-GB") : ""}  onChange={handleChange} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Invoice No :</label>
                <input type="text" name="invoiceNo" value={detail.grnheader_invoiceNumber}  onChange={handleChange} readOnly/>
              </div>
              <div className="form-group">
                <label>Invoice Date :</label>
                <input type="text" name="invoiceDate" value={detail.grnheader_invoiceDate ? new Date(detail.grnheader_invoiceDate).toLocaleDateString("en-GB") : ""}  onChange={handleChange} readOnly/>

              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Address 1 :</label>
                <input type="text" name="scode" value={subDetails.address1} readOnly/>
              </div>
              <div className="form-group">
                <label>Address 2 :</label>
                <input type="text" name="sname" value={subDetails.address2} readOnly/>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>City :</label>
                <input type="text" name="scode" value={subDetails.city} readOnly/>
              </div>
              <div className="form-group">
                <label>Pin code :</label>
                <input type="text" name="sname" value={subDetails.pincode} readOnly/>
              </div>
            </div>

            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Uom</th>
                    <th>GRN qty</th>
                    <th>Accepted Qty</th>
                    <th>Rejected Qty</th>
                    <th>Rejection Reason</th>
                    <th>Accp Value</th>
                    <th>Prepared By</th>
                  </tr>
                </thead>
                <tbody>
  {loading ? (
    <tr>
      <td colSpan="10" style={{ textAlign: "center" }}>
        Please wait, loading...
      </td>
    </tr>
  ) : selectedItems.length > 0 ? (
    selectedItems.map((item, index) => {
      const acceptedQuantity = quantities[index] || 0;
      const totalQuantity = item.grnDetail_poPendingQuantity;
      const rejectedQuantity =
        acceptedQuantity === 0 ? 0 : totalQuantity - acceptedQuantity;
      const acceptValue = acceptedQuantity * item.grnDetail_price;

      const discountValue =
        acceptValue * (item.grnDetail_discountPercentage / 100);
      const pfValue = acceptValue * (item.grnDetail_pfPercentage / 100);
      const taxValue = acceptValue * (item.grnDetail_taxPercentage / 100);
      const totalValue =
        item.grnHeader_freightCharges +
        acceptValue +
        taxValue +
        pfValue -
        discountValue;

      return (
        <tr key={index}>
          <td>{index + 1}</td>
          <td>{item.grnDetail_itemcode}</td>
          <td>{item.itemmaster_name}</td>
          <td>{item.itemMaster_purchaseUom}</td>
          <td>{totalQuantity}</td>
          <td>
            <input
              type="number"
              value={quantities[index] === "" ? "" : quantities[index]}
              min="0"
              max={item.grnDetail_poPendingQuantity}
              onChange={(e) => handleQuantityChange(index, e.target.value)}
            />
          </td>
          <td>{rejectedQuantity}</td>
          <td>
            <input
              type="text"
              name="rejectReason"
              value={rejectReasons[index] || ""}
              onChange={(e) => handleRejectReasonChange(index, e.target.value)}
            />
          </td>
          <td>{acceptValue.toFixed(2)}</td>
          <td>{user}</td>
        </tr>
      );
    })
  ) : (
    <tr>
      <td colSpan="10" style={{ textAlign: "center" }}>
        No items added
      </td>
    </tr>
  )}
</tbody>
              </table>

            </div>
            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>
          </form>
        </div>
      </div>

      <GrnPOModal showModal={showModal} closeModal={() => setShowModal(false)} branch={branch}  />
    </div>
  );
};

export default GrnInspection;
